/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocationWithRelations } from '../../models/location-with-relations';

export interface AdminFind$Params {
  inventoryId?: string;
  nested?: boolean;
}

export function adminFind(http: HttpClient, rootUrl: string, params?: AdminFind$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LocationWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, adminFind.PATH, 'get');
  if (params) {
    rb.query('inventoryId', params.inventoryId, {});
    rb.query('nested', params.nested, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LocationWithRelations>>;
    })
  );
}

adminFind.PATH = '/admin/locations';
